export function focusSelector(selector, { select = false } = {}) {
  const run = () => {
    const el = document.querySelector(selector);
    if (!el) return false;
    el.focus();
    if (typeof el.value === 'string') {
      if (select && el.select) el.select();
      else if (el.setSelectionRange) {
        const end = el.value.length;
        el.setSelectionRange(end, end);
      }
    }
    return true;
  };

  if (run()) return;
  requestAnimationFrame(() => {
    if (run()) return;
    requestAnimationFrame(run);
  });
}

export function focusField(scope, index) {
  focusSelector(`[data-focus="${scope}:${index}"]`);
}

export function previousIndex(tasks, from, showCompleted) {
  for (let index = from - 1; index >= 0; index -= 1) {
    if (showCompleted || !tasks[index].done) return index;
  }
  return null;
}

export function nextIndex(tasks, from, showCompleted) {
  for (let index = from + 1; index < tasks.length; index += 1) {
    if (showCompleted || !tasks[index].done) return index;
  }
  return null;
}
